import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";

export const CustomModal = ({
  open,
  content,
  title,
  isEdit,
  onSubmit,
  handleClose,
  isDisableSubmit,
  PaperProps,
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={PaperProps}
      sx={{
        ".MuiPaper-root": {
          borderRadius: "20px",
          width: PaperProps ? PaperProps : "482px",
        },
      }}
    >
      <DialogTitle
        sx={{ pb: "8px", pt: "20px", pl: "20px", pr: "20px", fontSize: "20px" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions sx={{ pr: "20px", pb: "20px" }}>
        <Button
          color="gray2"
          variant="outlined"
          onClick={handleClose}
          sx={{ height: "36px" }}
        >
          Cancel
        </Button>
        <Button
          disabled={isDisableSubmit}
          onClick={onSubmit}
          variant="contained"
          sx={{ height: "36px" }}
        >
          {isEdit ? "Update" : "Save"}
          {isDisableSubmit}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
